import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const fetchSavedDestructions = async (facilityIds, pageNumber = 1, pageSize = 10) => {
    const params = { pageNumber, pageSize };
    const ids = Array.isArray(facilityIds) ? facilityIds : facilityIds ? [facilityIds] : [];
    if (ids.length > 0) {
        params.facilityIds = ids;
    }

    const response = await SrxApi.get('/destructions/saved-destructions', {
        params,
        paramsSerializer: (p) =>
            Object.entries(p)
                .flatMap(([key, value]) =>
                    Array.isArray(value)
                        ? value.map((v) => `${key}=${encodeURIComponent(v)}`)
                        : `${key}=${encodeURIComponent(value)}`
                )
                .join('&'),
    });
    return response?.data;
};

const useSavedDestructions = (facilityIds, pageNumber = 1, pageSize = 10) => {
    const {
        data: savedDestructionsRaw = null,
        isFetching: isSavedDestructionsLoading,
        refetch: refetchSavedDestructions,
    } = useQuery(
        ['savedDestructions', facilityIds, pageNumber, pageSize],
        () => fetchSavedDestructions(facilityIds, pageNumber, pageSize),
        {
            staleTime: 0,
            onError: (error) => {
                const msg = error?.response?.data?.message || error?.message || 'Failed to load saved destructions';
                toast.error(msg);
            },
        }
    );

    return {
        savedDestructionsRaw,
        isSavedDestructionsLoading,
        refetchSavedDestructions,
    };
};

export default useSavedDestructions;
